/* tslint:disable */
/* eslint-disable */
/**
 * Shared Service API
 * Shared Service API documentation.
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, } from '../common';
// @ts-ignore
import { BASE_PATH, BaseAPI, } from '../base';
/**
 * InvitationsApi - axios parameter creator
 * @export
 */
export const InvitationsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {AcceptCognitoInvitationDto} acceptCognitoInvitationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationControllerAcceptCognitoInvitation: (acceptCognitoInvitationDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'acceptCognitoInvitationDto' is not null or undefined
            assertParamExists('invitationControllerAcceptCognitoInvitation', 'acceptCognitoInvitationDto', acceptCognitoInvitationDto);
            const localVarPath = `/invitation/accept-cognito`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(acceptCognitoInvitationDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Accept the invitation
         * @param {AcceptInvitationDto} acceptInvitationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationControllerAcceptInvitation: (acceptInvitationDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'acceptInvitationDto' is not null or undefined
            assertParamExists('invitationControllerAcceptInvitation', 'acceptInvitationDto', acceptInvitationDto);
            const localVarPath = `/invitation/accept`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(acceptInvitationDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Check if invitation already exists
         * @param {string} workspaceId
         * @param {string} emailAddress
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationControllerCheckExisting: (workspaceId, emailAddress, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists('invitationControllerCheckExisting', 'workspaceId', workspaceId);
            // verify required parameter 'emailAddress' is not null or undefined
            assertParamExists('invitationControllerCheckExisting', 'emailAddress', emailAddress);
            const localVarPath = `/invitation/check-existing`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (workspaceId !== undefined) {
                localVarQueryParameter['workspaceId'] = workspaceId;
            }
            if (emailAddress !== undefined) {
                localVarQueryParameter['emailAddress'] = emailAddress;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create and send a new invitation.
         * @param {CreateInvitationDto} createInvitationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationControllerCreate: (createInvitationDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createInvitationDto' is not null or undefined
            assertParamExists('invitationControllerCreate', 'createInvitationDto', createInvitationDto);
            const localVarPath = `/invitation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createInvitationDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get all invitations for a workspace
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        invitationControllerFindAll: (workspaceId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists('invitationControllerFindAll', 'workspaceId', workspaceId);
            const localVarPath = `/invitation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (workspaceId !== undefined) {
                localVarQueryParameter['workspaceId'] = workspaceId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get all titles for a workspace.
         * @param {Array<InvitationTemplateEnum>} [invitationTemplates]
         * @param {string} [name]
         * @param {string} [workspaceId]
         * @param {number} [page] The page number to retrieve, default &#x3D; 1
         * @param {number} [pageSize] Number of items to include per page, default &#x3D; 10
         * @param {string} [sortBy] The properties and order items should be sorted, default &#x3D; \&quot;created:asc\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationControllerFindAllV2: (invitationTemplates, name, workspaceId, page, pageSize, sortBy, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v2/invitation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (invitationTemplates) {
                localVarQueryParameter['invitationTemplates'] = invitationTemplates;
            }
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (workspaceId !== undefined) {
                localVarQueryParameter['workspaceId'] = workspaceId;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Verify the invitation code.
         * @param {string} code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationControllerFindAndVerify: (code, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('invitationControllerFindAndVerify', 'code', code);
            const localVarPath = `/invitation/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get invitation by Id.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationControllerFindOne: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('invitationControllerFindOne', 'id', id);
            const localVarPath = `/invitation/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete an invitation by Id.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationControllerRemove: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('invitationControllerRemove', 'id', id);
            const localVarPath = `/invitation/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Resend an invitation.
         * @param {string} id
         * @param {UpdateInvitationDto} updateInvitationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationControllerResend: (id, updateInvitationDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('invitationControllerResend', 'id', id);
            // verify required parameter 'updateInvitationDto' is not null or undefined
            assertParamExists('invitationControllerResend', 'updateInvitationDto', updateInvitationDto);
            const localVarPath = `/invitation/{id}/resend`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateInvitationDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update an existing invitation.
         * @param {string} id
         * @param {UpdateInvitationDto} updateInvitationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationControllerUpdate: (id, updateInvitationDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('invitationControllerUpdate', 'id', id);
            // verify required parameter 'updateInvitationDto' is not null or undefined
            assertParamExists('invitationControllerUpdate', 'updateInvitationDto', updateInvitationDto);
            const localVarPath = `/invitation/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateInvitationDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * InvitationsApi - functional programming interface
 * @export
 */
export const InvitationsApiFp = function (configuration) {
    const localVarAxiosParamCreator = InvitationsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {AcceptCognitoInvitationDto} acceptCognitoInvitationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationControllerAcceptCognitoInvitation(acceptCognitoInvitationDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.invitationControllerAcceptCognitoInvitation(acceptCognitoInvitationDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Accept the invitation
         * @param {AcceptInvitationDto} acceptInvitationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationControllerAcceptInvitation(acceptInvitationDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.invitationControllerAcceptInvitation(acceptInvitationDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Check if invitation already exists
         * @param {string} workspaceId
         * @param {string} emailAddress
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationControllerCheckExisting(workspaceId, emailAddress, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.invitationControllerCheckExisting(workspaceId, emailAddress, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Create and send a new invitation.
         * @param {CreateInvitationDto} createInvitationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationControllerCreate(createInvitationDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.invitationControllerCreate(createInvitationDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get all invitations for a workspace
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        invitationControllerFindAll(workspaceId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.invitationControllerFindAll(workspaceId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get all titles for a workspace.
         * @param {Array<InvitationTemplateEnum>} [invitationTemplates]
         * @param {string} [name]
         * @param {string} [workspaceId]
         * @param {number} [page] The page number to retrieve, default &#x3D; 1
         * @param {number} [pageSize] Number of items to include per page, default &#x3D; 10
         * @param {string} [sortBy] The properties and order items should be sorted, default &#x3D; \&quot;created:asc\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationControllerFindAllV2(invitationTemplates, name, workspaceId, page, pageSize, sortBy, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.invitationControllerFindAllV2(invitationTemplates, name, workspaceId, page, pageSize, sortBy, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Verify the invitation code.
         * @param {string} code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationControllerFindAndVerify(code, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.invitationControllerFindAndVerify(code, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get invitation by Id.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationControllerFindOne(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.invitationControllerFindOne(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Delete an invitation by Id.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationControllerRemove(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.invitationControllerRemove(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Resend an invitation.
         * @param {string} id
         * @param {UpdateInvitationDto} updateInvitationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationControllerResend(id, updateInvitationDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.invitationControllerResend(id, updateInvitationDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update an existing invitation.
         * @param {string} id
         * @param {UpdateInvitationDto} updateInvitationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationControllerUpdate(id, updateInvitationDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.invitationControllerUpdate(id, updateInvitationDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * InvitationsApi - factory interface
 * @export
 */
export const InvitationsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = InvitationsApiFp(configuration);
    return {
        /**
         *
         * @param {AcceptCognitoInvitationDto} acceptCognitoInvitationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationControllerAcceptCognitoInvitation(acceptCognitoInvitationDto, options) {
            return localVarFp
                .invitationControllerAcceptCognitoInvitation(acceptCognitoInvitationDto, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Accept the invitation
         * @param {AcceptInvitationDto} acceptInvitationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationControllerAcceptInvitation(acceptInvitationDto, options) {
            return localVarFp
                .invitationControllerAcceptInvitation(acceptInvitationDto, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Check if invitation already exists
         * @param {string} workspaceId
         * @param {string} emailAddress
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationControllerCheckExisting(workspaceId, emailAddress, options) {
            return localVarFp
                .invitationControllerCheckExisting(workspaceId, emailAddress, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create and send a new invitation.
         * @param {CreateInvitationDto} createInvitationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationControllerCreate(createInvitationDto, options) {
            return localVarFp
                .invitationControllerCreate(createInvitationDto, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all invitations for a workspace
         * @param {string} workspaceId
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        invitationControllerFindAll(workspaceId, options) {
            return localVarFp
                .invitationControllerFindAll(workspaceId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all titles for a workspace.
         * @param {Array<InvitationTemplateEnum>} [invitationTemplates]
         * @param {string} [name]
         * @param {string} [workspaceId]
         * @param {number} [page] The page number to retrieve, default &#x3D; 1
         * @param {number} [pageSize] Number of items to include per page, default &#x3D; 10
         * @param {string} [sortBy] The properties and order items should be sorted, default &#x3D; \&quot;created:asc\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationControllerFindAllV2(invitationTemplates, name, workspaceId, page, pageSize, sortBy, options) {
            return localVarFp
                .invitationControllerFindAllV2(invitationTemplates, name, workspaceId, page, pageSize, sortBy, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Verify the invitation code.
         * @param {string} code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationControllerFindAndVerify(code, options) {
            return localVarFp
                .invitationControllerFindAndVerify(code, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get invitation by Id.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationControllerFindOne(id, options) {
            return localVarFp
                .invitationControllerFindOne(id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete an invitation by Id.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationControllerRemove(id, options) {
            return localVarFp
                .invitationControllerRemove(id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Resend an invitation.
         * @param {string} id
         * @param {UpdateInvitationDto} updateInvitationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationControllerResend(id, updateInvitationDto, options) {
            return localVarFp
                .invitationControllerResend(id, updateInvitationDto, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update an existing invitation.
         * @param {string} id
         * @param {UpdateInvitationDto} updateInvitationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationControllerUpdate(id, updateInvitationDto, options) {
            return localVarFp
                .invitationControllerUpdate(id, updateInvitationDto, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * InvitationsApi - object-oriented interface
 * @export
 * @class InvitationsApi
 * @extends {BaseAPI}
 */
export class InvitationsApi extends BaseAPI {
    /**
     *
     * @param {AcceptCognitoInvitationDto} acceptCognitoInvitationDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvitationsApi
     */
    invitationControllerAcceptCognitoInvitation(acceptCognitoInvitationDto, options) {
        return InvitationsApiFp(this.configuration)
            .invitationControllerAcceptCognitoInvitation(acceptCognitoInvitationDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Accept the invitation
     * @param {AcceptInvitationDto} acceptInvitationDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvitationsApi
     */
    invitationControllerAcceptInvitation(acceptInvitationDto, options) {
        return InvitationsApiFp(this.configuration)
            .invitationControllerAcceptInvitation(acceptInvitationDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Check if invitation already exists
     * @param {string} workspaceId
     * @param {string} emailAddress
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvitationsApi
     */
    invitationControllerCheckExisting(workspaceId, emailAddress, options) {
        return InvitationsApiFp(this.configuration)
            .invitationControllerCheckExisting(workspaceId, emailAddress, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create and send a new invitation.
     * @param {CreateInvitationDto} createInvitationDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvitationsApi
     */
    invitationControllerCreate(createInvitationDto, options) {
        return InvitationsApiFp(this.configuration)
            .invitationControllerCreate(createInvitationDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all invitations for a workspace
     * @param {string} workspaceId
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof InvitationsApi
     */
    invitationControllerFindAll(workspaceId, options) {
        return InvitationsApiFp(this.configuration)
            .invitationControllerFindAll(workspaceId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all titles for a workspace.
     * @param {Array<InvitationTemplateEnum>} [invitationTemplates]
     * @param {string} [name]
     * @param {string} [workspaceId]
     * @param {number} [page] The page number to retrieve, default &#x3D; 1
     * @param {number} [pageSize] Number of items to include per page, default &#x3D; 10
     * @param {string} [sortBy] The properties and order items should be sorted, default &#x3D; \&quot;created:asc\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvitationsApi
     */
    invitationControllerFindAllV2(invitationTemplates, name, workspaceId, page, pageSize, sortBy, options) {
        return InvitationsApiFp(this.configuration)
            .invitationControllerFindAllV2(invitationTemplates, name, workspaceId, page, pageSize, sortBy, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Verify the invitation code.
     * @param {string} code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvitationsApi
     */
    invitationControllerFindAndVerify(code, options) {
        return InvitationsApiFp(this.configuration)
            .invitationControllerFindAndVerify(code, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get invitation by Id.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvitationsApi
     */
    invitationControllerFindOne(id, options) {
        return InvitationsApiFp(this.configuration)
            .invitationControllerFindOne(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete an invitation by Id.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvitationsApi
     */
    invitationControllerRemove(id, options) {
        return InvitationsApiFp(this.configuration)
            .invitationControllerRemove(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Resend an invitation.
     * @param {string} id
     * @param {UpdateInvitationDto} updateInvitationDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvitationsApi
     */
    invitationControllerResend(id, updateInvitationDto, options) {
        return InvitationsApiFp(this.configuration)
            .invitationControllerResend(id, updateInvitationDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update an existing invitation.
     * @param {string} id
     * @param {UpdateInvitationDto} updateInvitationDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvitationsApi
     */
    invitationControllerUpdate(id, updateInvitationDto, options) {
        return InvitationsApiFp(this.configuration)
            .invitationControllerUpdate(id, updateInvitationDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
